module.exports = __webpack_public_path__ + "static/media/servicestack.8dfcc5e1.svg";